<template>
    <FieldItem :id="id" :label="$t(fieldConfig.label)">
        <ElInputNumber
            v-model="fieldValue"
            class="search-preferences--number-input"
            size="small"
            :precision="0"
            :min="0"
            @keypress="isNumber($event)"
            @change="syncChange"
        />
    </FieldItem>
</template>

<script>
import { InputNumber } from 'element-ui';
import {
    FieldItem,
    FieldItemMixin,
} from '@patsnap-biz/bio-search-setting';

export default {
    name: 'NwNumberField',
    components: {
        FieldItem,
        ElInputNumber: InputNumber,
    },
    mixins: [FieldItemMixin],
    props: {
        fieldName: {
            type: String,
            required: true,
        },
    },
    mounted() {
        this.store.writeFieldValue(this.fieldName);
    },
};
</script>
